import React, { useState,useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  Avatar,
  AppBar,
  Toolbar,
  InputAdornment,
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  Tab,
  Tabs,
  TableSortLabel,
  TablePagination,
} from "@mui/material";
import { Notifications, CalendarToday, Search } from "@mui/icons-material";
import { Bar, Line } from "react-chartjs-2";
import "chart.js/auto";
import { urls } from "../../../urls/urls";
import { BASE_URL_TEST } from "../../../utils/baseUrl";
import { useFetch, useDelete, useUpdate } from "../../../hooks";
import {
  AppHeaderBar,
  CustomDataCard,
  VendorappBar,
} from "../../../components";

import { useDispatch, useSelector } from "react-redux";
const DashboardContent = ({ onBackScreenName }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [salesPeriod, setSalesPeriod] = useState('today'); // today, week, month, year
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [searchTx, setSearchTx] = useState("");
  const [txSortField, setTxSortField] = useState("created_at");
  const [txSortDir, setTxSortDir] = useState("desc");
  const [txPage, setTxPage] = useState(0);
  const [txRowsPerPage, setTxRowsPerPage] = useState(5);

  const appStateToken = useSelector((state) => state);
  const userDetails = useSelector((state) => state.user.userdetails);
  const loginToken = useSelector((state) => state.user.logintoken);

  console.log("userDetails logout", userDetails);
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };
 useEffect(() => {
   if (userDetails?.vendor_id) {
     fetchData();
   }
  }, [userDetails?.vendor_id]);

  useEffect(() => {
    if (userDetails?.vendor_id) {
      fetchSalesData();
    }
  }, [salesPeriod, userDetails?.vendor_id]);

  useEffect(() => {
    if (userDetails?.vendor_id) {
      console.log('yamunaId', userDetails.vendor_id);
      fetchGraphData({
        vendor_id: userDetails.vendor_id,
        year: selectedYear
      });
    }
  }, [userDetails?.vendor_id, selectedYear]);

  const {
    data: dashboardResponse,
    isLoading: isDashboardLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getdashBoardCounts",userDetails?.vendor_id), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

    const {
      data: salesDataResponse,
      isLoading: isSalesLoading,
      error: salesError,
      fetchData: fetchSalesData,
    } = useFetch(
      BASE_URL_TEST + urls("getSalesReport", userDetails?.vendor_id),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: loginToken ? `Bearer ${loginToken}` : "",
        },
        body: JSON.stringify({ period: salesPeriod }),
      }
    );

  const {
    data: graphDataResponse,
    isLoading: isGraphLoading,
    error: graphError,
    fetchData: fetchGraphData,
  } = useFetch(
    BASE_URL_TEST + urls("getSalesGraphReport"),
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    }
  );

 const dashboardData = dashboardResponse?.data;
 const salesReportData = salesDataResponse?.data;
 const graphData = graphDataResponse?.data;
 console.log('dashboardData',dashboardData);
 console.log('salesReportData', salesReportData);
 console.log('graphData', graphData);

 // Get the current sales based on selected period
 const getCurrentSales = () => {
   if (!salesReportData) return 0;
   switch(salesPeriod) {
     case 'today':
       return salesReportData.today_sales || 0;
     case 'week':
       return salesReportData.week_sales || 0;
     case 'month':
       return salesReportData.month_sales || 0;
     case 'year':
       return salesReportData.year_sales || 0;
     default:
       return 0;
   }
 };

 // Month names for the graph
 const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

 // Process graph data
 const salesData = {
   labels: graphData ? graphData.map(item => monthNames[item.month - 1]) : monthNames,
   datasets: [
     {
       label: "Revenue",
       data: graphData ? graphData.map(item => item.total_sales) : [],
       borderColor: "rgba(75, 192, 192, 1)",
       borderWidth: 2,
       fill: false,
     },
   ],
 };
  const cards = [
    {
      title: "Products left in inventory",
      value: dashboardData?.product_left_inventory || "0",
      image: "/totalProducts.svg",
    },
    {
      title: "Today Total Order Count",
      value: dashboardData?.today_total_orders?.toString() || "0",
      image: "/orders.svg"
    },
    {
      title: "Cancelled Orders",
      value: dashboardData?.cancelled_orders?.toString() || "0",
      image: "/orders.svg"
    },
    {
      title: "Total Order Values",
      value: dashboardData?.total_order_sales 
        ? `₹${parseFloat(dashboardData.total_order_sales).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
        : "₹0.00",
      image: "/Flag.svg"
    },
    {
      title: "New Orders",
      value: dashboardData?.new_orders?.toString() || "0",
      image: "/topProducts.svg"
    },
  ];

   const transactions = dashboardData?.last_ten_transactions || [];
   console.log('transactions',transactions)

  const mostPurchasedProductsData = {
    labels: ["Light1", "Light2", "Light3", "Light4", "Light5", "Light6"],
    datasets: [
      {
        label: "Products",
        data: [100, 150, 200, 120, 130, 140],
        backgroundColor: [
          "rgba(75, 192, 192, 0.5)",
          "rgba(192, 75, 75, 0.5)",
          "rgba(75, 75, 192, 0.5)",
          "rgba(192, 192, 75, 0.5)",
          "rgba(75, 192, 75, 0.5)",
          "rgba(192, 75, 192, 0.5)",
        ],
      },
    ],
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#EEF2FF",
          p: 3,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* <AppHeaderBar
          title={"Welcome Dashboard"}
          onBackScreenName={handleScreeName}
        /> */}
        <VendorappBar title={" Dashboard"} onBackScreenName={handleScreeName} />
        <Box sx={{ flexGrow: 1 }}>
          <>
            <Grid container spacing={1}>
              {cards.map((card, index) => (
                <Grid item xs={12} sm={6} md={2.4} key={index}>
                  <Card
                    sx={{
                      borderRadius: "12px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      mt: 3,
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "nowrap",
                        }}
                      >
                        <img
                          src={card.image}
                          alt={card.title}
                          style={{ width: "40px", marginRight: "10px" }}
                        />
                        <Box>
                          <Typography
                            color="textSecondary"
                            gutterBottom
                            noWrap
                            sx={{ fontSize: "0.658rem", fontWeight: "bold" }}
                          >
                            {card.title}
                          </Typography>
                          <Typography
                            variant="h5"
                            component="div"
                            sx={{
                              fontSize: "1rem",
                              fontWeight: "bold",
                              wordWrap: "break-word",
                            }}
                          >
                            {card.value}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>

            <Grid
              container
              spacing={2}
              sx={{ mt: 2, display: "flex", flexDirection: "row" }}
            >
              {/* Your Sales Report Section */}
              <Grid item xs={12} md={12}>
                <Card
                  sx={{
                    borderRadius: "12px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <CardContent>
                    <Grid container spacing={2}>
                      {/* Sales Report Section */}
                      <Grid item xs={12} md={6}>
                        <Typography
                          variant="h6"
                          component="div"
                          sx={{ fontWeight: "bold" }}
                        >
                          TOTAL ORDERS RECEIVED
                        </Typography>
                        <Typography variant="h4" component="div" sx={{ mt: 2 }}>
                          {isSalesLoading ? (
                            "Loading..."
                          ) : (
                            `₹${parseFloat(getCurrentSales()).toLocaleString('en-IN', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}`
                          )}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                          {salesPeriod === 'today' && 'Today\'s Sales'}
                          {salesPeriod === 'week' && 'This Week\'s Sales'}
                          {salesPeriod === 'month' && 'This Month\'s Sales'}
                          {salesPeriod === 'year' && 'This Year\'s Sales'}
                        </Typography>
                        <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                          <Button
                            variant={salesPeriod === 'today' ? 'contained' : 'text'}
                            size="small"
                            onClick={() => setSalesPeriod('today')}
                            sx={{
                              minWidth: '40px',
                              color: salesPeriod === 'today' ? '#fff' : '#3f51b5',
                              backgroundColor: salesPeriod === 'today' ? '#3f51b5' : 'transparent',
                              '&:hover': {
                                backgroundColor: salesPeriod === 'today' ? '#303f9f' : 'rgba(63, 81, 181, 0.04)',
                              }
                            }}
                          >
                            1D
                          </Button>
                          <Button
                            variant={salesPeriod === 'week' ? 'contained' : 'text'}
                            size="small"
                            onClick={() => setSalesPeriod('week')}
                            sx={{
                              minWidth: '40px',
                              color: salesPeriod === 'week' ? '#fff' : '#3f51b5',
                              backgroundColor: salesPeriod === 'week' ? '#3f51b5' : 'transparent',
                              '&:hover': {
                                backgroundColor: salesPeriod === 'week' ? '#303f9f' : 'rgba(63, 81, 181, 0.04)',
                              }
                            }}
                          >
                            1W
                          </Button>
                          <Button
                            variant={salesPeriod === 'month' ? 'contained' : 'text'}
                            size="small"
                            onClick={() => setSalesPeriod('month')}
                            sx={{
                              minWidth: '40px',
                              color: salesPeriod === 'month' ? '#fff' : '#3f51b5',
                              backgroundColor: salesPeriod === 'month' ? '#3f51b5' : 'transparent',
                              '&:hover': {
                                backgroundColor: salesPeriod === 'month' ? '#303f9f' : 'rgba(63, 81, 181, 0.04)',
                              }
                            }}
                          >
                            1M
                          </Button>
                          <Button
                            variant={salesPeriod === 'year' ? 'contained' : 'text'}
                            size="small"
                            onClick={() => setSalesPeriod('year')}
                            sx={{
                              minWidth: '40px',
                              color: salesPeriod === 'year' ? '#fff' : '#3f51b5',
                              backgroundColor: salesPeriod === 'year' ? '#3f51b5' : 'transparent',
                              '&:hover': {
                                backgroundColor: salesPeriod === 'year' ? '#303f9f' : 'rgba(63, 81, 181, 0.04)',
                              }
                            }}
                          >
                            1Y
                          </Button>

                  
                  
                        </Box>
                          <Typography variant="h6" component="div" 
                           sx={{ fontWeight: "bold" }}>
                      Total Users
                    </Typography>
                    <Typography variant="h4" component="div" sx={{ mt: 2 }}>
                     {dashboardData?.total_customers || "0"}
                    </Typography>
                      </Grid>

                      {/* Revenue Year Section */}
                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            variant="h6"
                            component="div"
                            sx={{ fontWeight: "bold" }}
                          >
                            Revenue Year - {selectedYear}
                          </Typography>
                          <FormControl size="small">
                            <Select
                              value={selectedYear}
                              onChange={(e) => setSelectedYear(e.target.value)}
                              sx={{
                                fontWeight: "bold",
                                color: "#3f51b5",
                                ".MuiOutlinedInput-notchedOutline": {
                                  border: 0,
                                },
                              }}
                            >
                              <MenuItem value={2023}>2023</MenuItem>
                              <MenuItem value={2024}>2024</MenuItem>
                              <MenuItem value={2025}>2025</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                        <Box sx={{ mt: 2 }}>
                          {isGraphLoading ? (
                            <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', py: 4 }}>
                              Loading graph data...
                            </Typography>
                          ) : (
                            <Line data={salesData} height={100} />
                          )}
                        </Box>
                       
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ mt: 2 }} direction="column">
              <Grid item xs={12} md={8}>
                <Card
                  sx={{
                    borderRadius: "12px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    width: "92%",
                  }}
                >
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
                      Last Transaction
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 2,
                      }}
                    >
                      <TextField
                        placeholder="Search"
                        value={searchTx}
                        onChange={(e) => setSearchTx(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        variant="outlined"
                        size="small"
                        sx={{ maxWidth: 300 }}
                      />
                    </Box>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            {[
                              { id: "vcart_number", label: "Order ID" },
                              { id: "name", label: "Customer" },
                              { id: "delivery_mode", label: "Delivery" },
                              { id: "created_at", label: "Date" },
                              { id: "total_amount", label: "Price" },
                              { id: "payment_method", label: "Type of Payment" },
                              { id: "order_status", label: "Status" },
                            ].map((col) => (
                              <TableCell key={col.id} sx={{ whiteSpace: "nowrap" }}>
                                <TableSortLabel
                                  active={txSortField === col.id}
                                  direction={txSortField === col.id ? txSortDir : "asc"}
                                  onClick={() => {
                                    if (txSortField === col.id) {
                                      setTxSortDir((d) => (d === "asc" ? "desc" : "asc"));
                                    } else {
                                      setTxSortField(col.id);
                                      setTxSortDir("asc");
                                    }
                                    setTxPage(0);
                                  }}
                                >
                                  {col.label}
                                </TableSortLabel>
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(() => {
                            const filtered = transactions.filter((t) => {
                              const q = searchTx.toLowerCase();
                              return (
                                t.vcart_number?.toLowerCase().includes(q) ||
                                t.cart_number?.toLowerCase().includes(q) ||
                                t.delivery_mode?.toLowerCase().includes(q) ||
                                t.name?.toLowerCase().includes(q)
                              );
                            });
                            const sorted = [...filtered].sort((a, b) => {
                              const aVal = a[txSortField] ?? "";
                              const bVal = b[txSortField] ?? "";
                              if (txSortField === "created_at" || txSortField === "total_amount") {
                                return txSortDir === "asc"
                                  ? new Date(aVal) - new Date(bVal) || aVal - bVal
                                  : new Date(bVal) - new Date(aVal) || bVal - aVal;
                              }
                              return txSortDir === "asc"
                                ? String(aVal).localeCompare(String(bVal))
                                : String(bVal).localeCompare(String(aVal));
                            });
                            const paginated = sorted.slice(
                              txPage * txRowsPerPage,
                              txPage * txRowsPerPage + txRowsPerPage
                            );
                            if (paginated.length === 0) {
                              return (
                                <TableRow>
                                  <TableCell colSpan={7} align="center">
                                    No transactions found
                                  </TableCell>
                                </TableRow>
                              );
                            }
                            return paginated.map((transaction) => (
                              <TableRow key={transaction.cart_vendor_id}>
                                <TableCell sx={{ whiteSpace: "nowrap" }}>{transaction.vcart_number || transaction.cart_number}</TableCell>
                                <TableCell sx={{ whiteSpace: "nowrap" }}>{transaction.name || "N/A"}</TableCell>
                                <TableCell>{transaction.delivery_mode || "N/A"}</TableCell>
                                <TableCell sx={{ whiteSpace: "nowrap" }}>{transaction.created_at}</TableCell>
                                <TableCell>{transaction.total_amount}</TableCell>
                                <TableCell>{transaction.payment_method}</TableCell>
                                <TableCell>
                                  <Typography color="green">{transaction.order_status}</Typography>
                                </TableCell>
                              </TableRow>
                            ));
                          })()}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      component="div"
                      count={transactions.filter((t) => {
                        const q = searchTx.toLowerCase();
                        return (
                          t.vcart_number?.toLowerCase().includes(q) ||
                          t.cart_number?.toLowerCase().includes(q) ||
                          t.delivery_mode?.toLowerCase().includes(q) ||
                          t.name?.toLowerCase().includes(q)
                        );
                      }).length}
                      page={txPage}
                      onPageChange={(_, newPage) => setTxPage(newPage)}
                      rowsPerPage={txRowsPerPage}
                      onRowsPerPageChange={(e) => { setTxRowsPerPage(parseInt(e.target.value, 10)); setTxPage(0); }}
                      rowsPerPageOptions={[5, 10, 25]}
                    />
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={4}>
                {/* <Card
                  sx={{
                    borderRadius: "12px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <CardContent>
                    <Typography variant="h6" component="div">
                      Most Purchased Products
                    </Typography>
                    <Bar data={mostPurchasedProductsData} />
                  </CardContent>
                </Card> */}
                {/* <Card
                  sx={{
                    mt: 2,
                    borderRadius: "12px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <CardContent>
                    <Typography variant="h6" component="div">
                      Present Discount
                    </Typography>
                    <Typography variant="h4" component="div" sx={{ mt: 2 }}>
                      40%
                    </Typography>
                  </CardContent>
                </Card> */}
                {/* <Card
                  sx={{
                    mt: 2,
                    borderRadius: "12px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <CardContent>
                    <Typography variant="h6" component="div">
                      Total Users
                    </Typography>
                    <Typography variant="h4" component="div" sx={{ mt: 2 }}>
                     {dashboardData?.total_customers || "0"}
                    </Typography>
                  </CardContent>
                </Card> */}
              </Grid>
            </Grid>
          </>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardContent;
